<template>
  <div class="rateList">
    <transition name="fade" appear>
        <div style="margin-top:10px;">
        <vx-card>
            <div style="">
                <div slot="header" style="display: flex; justify-content: space-between;">
                    <p style="font-size:16px; font-weight:bold; margin-top:10px">과목별 등급컷</p>
                    <div style="display:flex">
                        <vs-button v-if="scoreList.length" @click="activePrompt = !activePrompt" style="width:120px; height:35px; padding:0; margin-right:10px; font-size:12px;" icon-pack="feather" icon="icon-plus">감점요소 추가</vs-button>
                        <vs-button @click="addInput()" style="width:100px; height:35px; padding:0; margin-right:10px; font-size:12px;" icon-pack="feather" icon="icon-plus">과목 추가</vs-button>
                    </div>
                </div>
                <div style="width:100%">
                    <div style="margin-top:15px;">
                        <div style="max-height:260px; overflow-y:auto;">
                            <div v-for="(item , index) in scoreList" :key="index" @click="activeIndex = index">
                                <div style="display:flex; justify-content:space-between; width:100%; margin-top:5px;">
                                    <vs-select
                                    :label="'과목' + (index+1)"
                                    v-model="item.subject_name"
                                    style="width:25%">

                                    <vs-select-item
                                        v-for="(value , count) in inquirylist"
                                        :key="count"
                                        :value="value.subject_name"
                                        :text="value.subject_name" />
                                    </vs-select>
                                    <vs-input label="표준점수" type="text" name="" v-model="item.score" style="width:25%;" />
                                    <vs-button @click="deleteInput(index)" type="border" icon-pack="feather" size="small" icon="icon-trash-2" color="danger" style="margin: 25px 0 0 20px;"></vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
        </div>
    </transition>
    <vs-prompt title="감점 요소 추가" @accept="updateSubjectInfo" accept-text="업로드" cancel-text="취소" :active.sync="activePrompt">
        <form @submit.prevent>
            <vs-select
            :label="'과목을 선택하세요'"
            v-model="targetValue"
            style="width:50%">
            <vs-select-item
                v-for="(value , count) in scoreList"
                :key="count"
                :value="value"
                :text="value.subject_name" />
            </vs-select>
            <vs-input class="w-full mt-4" :label="index + '등급'" v-model="subjectLevels[item]" v-for="(item, index) in key" :key="index" />
        </form>
    </vs-prompt>
  </div>
</template>

<script>
import { DeleteIcon , XIcon } from 'vue-feather-icons'
export default {
    props: ['rate'],
    components: {
            DeleteIcon,
            XIcon
        },
    data() {
        return {
            incState: [],
            subjectList: [],
            scoreList: [],
            totalSum: 0,
            inquirylist: [
                {subject_name: '국어' , subject: 'kor'},
                {subject_name: '수학' , subject: 'mat'},
                // {subject_name: '수학' , subject: 'mat'},
                {subject_name: '영어' , subject: 'eng'},
                {subject_name: '한국사' , subject: 'his'},
                {subject_name: '경제' , subject: 'opt'},
                {subject_name: '동아시아사' , subject: 'opt'},
                {subject_name: '물리1', subject: 'opt'},
                {subject_name: '물리2', subject: 'opt'},
                {subject_name: '사회문화', subject: 'opt'},
                {subject_name: '생명1', subject: 'opt'},
                {subject_name: '생명2', subject: 'opt'},
                {subject_name: '생활과윤리', subject: 'opt'},
                {subject_name: '세계사', subject: 'opt'},
                {subject_name: '세계지리', subject: 'opt'},
                {subject_name: '윤리와사상', subject: 'opt'},
                {subject_name: '정치와법', subject: 'opt'},
                {subject_name: '지구과학1', subject: 'opt'},
                {subject_name: '지구과학2', subject: 'opt'},
                {subject_name: '한국지리', subject: 'opt'},
                {subject_name: '화학1', subject: 'opt'},
                {subject_name: '화학2', subject: 'opt'},
                {subject_name: '제2외국어', subject: 'opt'},
                {subject_name: '한문', subject: 'opt'}
            ],
            key: [
                'grd1',
                'grd2',
                'grd3',
                'grd4',
                'grd5',
                'grd6',
                'grd7',
                'grd8',
                'grd9',
            ],
            subjectLevels: {
                grd1: 0,
                grd2: 0,
                grd3: 0,
                grd4: 0,
                grd5: 0,
                grd6: 0,
                grd7: 0,
                grd8: 0,
                grd9: 0,
            },
            activeIndex: 0,
            activePrompt: false,
            targetValue: null,
        }
    },
    created() {
        if(this.rate) {
            this.scoreList = JSON.parse(JSON.stringify(this.rate))
            console.log(this.scoreList)
            for(var i in this.rate) {
                this.$set(this.subjectList , i , {
                    subject_name: this.rate[i].subject_name,
                    subject: this.rate[i].subject
                })
                if(this.scoreList[i].increase) {
                    this.$set(this.incState , i , true)
                }
            }
        }
    },
    watch: {
        targetValue() {
            if(this.targetValue.subtract_point) {
                for(var i in this.key) {
                    this.$set(this.subjectLevels , this.key[i] , this.targetValue.subtract_point[this.key[i]])
                }
            } else {
                for(var j in this.key) {
                    this.$set(this.subjectLevels , this.key[j] , 0)
                }
            }
        },
        subjectList: {
            deep:true,
            handler() {
                this.$set(this.scoreList[this.activeIndex] , 'subject_name' , JSON.parse(JSON.stringify(this.subjectList[this.activeIndex].subject_name)))
                this.$set(this.scoreList[this.activeIndex] , 'subject' , JSON.parse(JSON.stringify(this.subjectList[this.activeIndex].subject)))
            }
        },
        scoreList: {
            deep: true,
            handler() {
                var index = this.inquirylist.findIndex((item)=> {
                    return this.scoreList[this.activeIndex].subject_name == item.subject_name
                })
                if(index != -1) {
                    this.$set(this.scoreList[this.activeIndex] , 'subject' , this.inquirylist[index].subject)
                }
                this.$emit('rate' , this.scoreList)
            }
        }
    },
    methods: {
        updateSubjectInfo() {
            var index = this.scoreList.findIndex((item) => {
                return this.targetValue.subject_name == item.subject_name
            })
            this.$set(this.scoreList[index] , 'subtract_point' , JSON.parse(JSON.stringify(this.subjectLevels)))
        },
        setModel(val , index) {
            this.scoreList[index].subject_name = val.subject_name
            this.scoreList[index].subject = val.subject
            // console.log(val.name)
        },
        addInput() {
            this.scoreList.push({
                subject_name: '',
                subject: '',
                score: 0,
                increase: 1,
                 subtract_point: {
                    grd1: 0,
                    grd2: 0,
                    grd3: 0,
                    grd4: 0,
                    grd5: 0,
                    grd6: 0,
                    grd7: 0,
                    grd8: 0,
                    grd9: 0,
                }
            })
            this.$vs.notify({
                title: '추가',
                text: '과목이 추가되었습니다',
                // iconPack: 'feather',
                // icon: 'icon-thumbs-up',
                color: 'success'
            })
        },
        deleteInput(val) {
            this.scoreList.splice(val , 1)
            this.$vs.notify({
                title: '삭제',
                text: '과목이 삭제되었습니다',
                // iconPack: 'feather',
                // icon: 'icon-delete',
                color: 'danger'
            })
        }
    }
}
</script>
